import { FailedResponse, SuccessResponse } from './response'
import { Bool, ID } from '../types/UtilityTypes'

export interface StatisticsQuery {
    brands: ID[],
    clients: ID[],
    date_from: string,
    date_to: string
}
export interface ByClientQuery extends StatisticsQuery {
    compare?: Bool,
}

export interface ByUserQuery extends StatisticsQuery {
    users: ID[],
    managers: ID[],
    departments?: ID[],
    directions?: ID[],
}

export interface ByObjectQuery extends StatisticsQuery {
    users: ID[],
    managers: ID[],
    departments: ID[],
    work_objects: ID[],
}

type Tuple = [number, number]

export interface ByClientData {
    projects: {
        opened: Tuple,
        closed: Tuple,
        canceled: Tuple,
    },
    project_work_objects: {
        design: {
            won: Tuple,
            lost: Tuple,
            canceled: Tuple,
        },
        production: {
            won: Tuple,
            lost: Tuple,
            canceled: Tuple,
        }
    },
    tasks: {
        opened: Tuple,
        closed: Tuple,
    }
}

export interface ByManagerData {
    projects: {
        opened: number,
        closed: number,
        canceled: number,
    },
    project_work_objects: {
        opened: number,
        closed: number,
        design: {
            won: number,
            lost: number,
            canceled: number,
        },
        production: {
            won: number,
            lost: number,
            canceled: number,
        },
    },
    tasks: {
        opened: number,
        closed: number,
    }
}
export interface ByProjectData {
    dizayn?: {
        canceled: number,
        closed: number,
        opened: number,
    },
    'tyazhelyy-posm'?: {
        canceled: number,
        closed: number,
        opened: number,
    },
    'karton-cardboard'?: {
        canceled: number,
        closed: number,
        opened: number,
    },
    other?: {
        canceled: number,
        closed: number,
        opened: number,
    },
    total?: {
        canceled: number,
        closed: number,
        opened: number,
    }
}
export interface ByTaskData {
    '2d'?: {
        closed: number,
        opened: number,
    },
    '3d'?: {
        closed: number,
        opened: number,
    },
    'arkhiv'?: {
        closed: number,
        opened: number,
    },
    'chertezh'?: {
        closed: number,
        opened: number,
    },
    'digital'?: {
        closed: number,
        opened: number,
    },
    'instruktsiya'?: {
        closed: number,
        opened: number,
    },
    'kastomizatsiya'?: {
        closed: number,
        opened: number,
    },
    'obrazets'?: {
        closed: number,
        opened: number,
    },
    'prepress'?: {
        closed: number,
        opened: number,
    },
    'raschet'?: {
        closed: number,
        opened: number,
    },
    'total'?: {
        closed: number,
        opened: number,
    },
    'tsvetoproba'?: {
        closed: number,
        opened: number,
    },
    'video'?: {
        closed: number,
        opened: number,
    },
}

export interface ByUserData {
    projects: {
        closed: number,
    },
    project_work_objects: {
        closed: number,
        tenders: {
            won: number,
            lost: number,
            canceled: number,
        },
        design: {
            won: number,
            lost: number,
            canceled: number,
        },
        production: {
            won: number,
            lost: number,
            canceled: number,
        },
    },
    tasks: {
        closed: number,
        days_in_work: number,
    },
}

export interface ByObjectData {
    project_work_objects: {
        tenders: {
            won: number,
            lost: number,
            canceled: number,
        },
        design: {
            won: number,
            lost: number,
            canceled: number,
        },
        production: {
            won: number,
            lost: number,
            canceled: number,
        }
    }
}

export interface StatisticsData<T> {
    rows?: StatisticsRow<T>[],
    total: T,
}

export interface StatisticsRow<T> extends StatisticsData<T> {
    name: string,
}

export type StatisticsResponse<T> = (StatisticsData<T> & SuccessResponse) | FailedResponse

export type StatisticsType =
    'project-opened'
    | 'project-closed'
    | 'project-canceled'
    | 'object-design-won'
    | 'object-design-lost'
    | 'object-design-canceled'
    | 'object-production-won'
    | 'object-production-lost'
    | 'object-production-canceled'
    | 'task-opened'
    | 'task-closed'

export interface StatisticsInWork {
    projects: number,
    project_work_objects: number,
    tenders: number,
    tasks: number,
}